import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { SearchResponseModel, SearchResultItem } from 'src/app/core/models/search-response-model';
import { SearchResultTypes } from 'src/app/util/constantes';
import { ModalConfig } from '../modal/modal-config';

@Component({
    selector: 'app-response-search',
    templateUrl: './response-search.component.html',
    styleUrls: ['./response-search.component.scss'],
    standalone: false
})
export class ResponseSearchComponent {
  searchResponse: SearchResponseModel;
  public modalConfig: ModalConfig;
  faFolderOpen = faFolderOpen;

  constructor(private router: Router) { }

  ngOnInit() {
    this.modalConfig = {
      modalTitle: "Buscador",
      ...this.modalConfig,
    };

  }

  redirectResult(result: SearchResultItem) {
    switch (result.tipo) {
      case SearchResultTypes.REPORT:
        this.router.navigate(['data-visualization/reports'], {
          queryParams: { origen: result.origen, area: result.area }
        });
        break;
      case SearchResultTypes.BOARD:
        this.router.navigate(['/data-visualization/boards'], {
          queryParams: { origen: result.origen, area: result.area }
        });
        break;
      case SearchResultTypes.FILE_KNOWLEDGE_BANK:
        this.router.navigate(['/knowledge-bank/explore'], {
          queryParams: { origen: result.origen, area: result.area }
        });
        break;
      default:
        console.warn('Tipo de resultado no reconocido:', result.tipo);
    }
  }
}
